import { Component, OnInit } from '@angular/core';
import { User } from '../../_models/user';
import { FormGroup, FormBuilder } from '@angular/forms';
import { UserService } from '../../_services/user.service';
import { ModalDefaultService } from '../../modal-default/modal-default.service';

@Component({
  selector: 'app-user-list',
  templateUrl: './user-list.component.html',
  styleUrls: ['./user-list.component.css']
})
export class UserListComponent implements OnInit {
  users: User[];
  searchForm: FormGroup;
  loading = false;
  submitted = false;
  error = '';
  page = 1;
  totalResults = 0;
  resultsPerPage = 0;
  deleteId = 0;
  isActive = false;

  constructor(private formBuilder: FormBuilder, private userService: UserService, private modalService: ModalDefaultService) { }

  ngOnInit() {
    this.searchForm = this.formBuilder.group({ userName: [''], onlyActives: [false] });

    this.getUsers(this.page, this.searchForm.controls.userName.value, this.searchForm.controls.onlyActives.value);
  }

  onSubmit() {
    if (this.searchForm.invalid) {
      return;
    }

    this.page = 1;
    this.getUsers(this.page, this.searchForm.controls.userName.value, this.searchForm.controls.onlyActives.value)
  }

  onSelectedPage() {
    this.getUsers(this.page, this.searchForm.controls.userName.value, this.searchForm.controls.onlyActives.value)
  }

  private getUsers(page: number, userName: string, onlyActives: boolean) {
    this.submitted = true;

    this.loading = true;
    this.userService.getUsers(page, userName, onlyActives)
      .subscribe(
        data => {
          this.page = data.pageNumber;
          this.resultsPerPage = data.resultsPerPage;
          this.totalResults = data.totalResults;
          this.users = data.response;
          this.loading = false;
        },
        error => {
          this.error = error;
          this.loading = false;
        });
  }

  delete(id: number) {
    this.userService.deleteUser(id)
      .subscribe(
        data => {
          this.modalService.closeDefault();
          this.deleteId = 0;
          this.ngOnInit();
        },
        error => {
          this.modalService.closeDefault();
          this.deleteId = 0;
          this.error = error;
        });
  }

  showDeleteModal(content, id, isActive) {

    this.deleteId = id;
    this.isActive = isActive;

    this.modalService.openDefault(content, null).result.then(
      (closeResult) => {
        if (closeResult == "send")
          console.log("modal closed : ", closeResult);
      }, (dismissReason) => {
        console.log("modal dismissed when used pressed ESC button");
      });
  }

}
